import classNames from 'clsx';
import React, { memo, ReactElement } from 'react';
import { areEqual, ListChildComponentProps } from 'react-window';
import { AdvBanner } from 'reactApp/ui/Mobile/Datalist/AdvBanner/AdvBanner';

import styles from './VirtualList.css';

export const VirtualListRow = memo(function VirtualListRow(props: ListChildComponentProps): ReactElement | null {
    const { index, style, data } = props;
    const { list, itemActiveIndex, renderItem, dividerSize } = data;
    const key = typeof list[index] === 'string' ? list[index] : list[index].id;
    const handleRef = index === itemActiveIndex ? data.handleRef : null;

    return list[index].divider ? (
        <div
            style={style}
            key={key + index}
            className={classNames({
                [styles.dividerContainer]: true,
                [styles.dividerList]: true,
                [styles.dividerAdv]: list[index].showAdv,
            })}
        >
            <div
                className={classNames({
                    [styles.divider]: true,
                    [styles[`divider_${dividerSize}`]]: !!dividerSize,
                })}
            >
                {list[index].text}
                {list[index].showAdv && <AdvBanner />}
            </div>
        </div>
    ) : (
        <div style={style} key={key + index} ref={handleRef}>
            {renderItem(data.list[index], { index })}
        </div>
    );
}, areEqual);
